import { render, staticRenderFns } from "./TableCollaborator.vue?vue&type=template&id=446eb8ea"
import script from "./TableCollaborator.vue?vue&type=script&lang=js"
export * from "./TableCollaborator.vue?vue&type=script&lang=js"
import style0 from "./TableCollaborator.vue?vue&type=style&index=0&id=446eb8ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports